import { Component, inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ProductDetailComponent } from 'gung-standard';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { map, switchMap, first } from 'rxjs';
import { forkJoin, of } from 'rxjs';

@Component({
    selector: 'otto-olsen-product-details-modal',
    templateUrl: './otto-olsen-product-details-modal.component.html',
    styleUrls: ['./otto-olsen-product-details-modal.component.scss'],
    standalone: false
})
export class OttoOlsenProductDetailsModalComponent extends ProductDetailComponent implements OnInit {
  protected router = inject(Router);
  public activeModal = inject(NgbActiveModal);

  lang = localStorage.getItem('selectedLanguage');

  public imageIdString = 'productImage';
  @ViewChild(NgbCarousel)
  private myCarousel: NgbCarousel;
  @ViewChild('scrollContainer')
  scrollingImages: ElementRef;

  ngOnInit(): void {
    const baseObservable = this.route.params.pipe(
      map(params => {
        return (params.productId as string) || this.productId;
      }),
      switchMap(productId =>
        forkJoin({
          productId: of(productId),
          multistock: this.authService.getCurrentUser().pipe(
            first(),
            map(user => user.managedMultistockIds[0])
          )
        })
      ),
      switchMap(({ productId, multistock }) =>
        forkJoin({
          product: this.productService.getProduct(productId),
          availability: of(null), // this.availabilityService.getAvailability(productId, multistock),
          price: of(null), // this.priceService.getCurrentCustomerPrice(productId).pipe(first()),
          user: this.authService.getCurrentUser().pipe(first()),
          flow: this.gungFlowService.getSelectedFlow().pipe(first())
        })
      )
    );
    this.handleObservable(baseObservable);
  }

  select(index: number): void {
    this.myCarousel.select(this.imageIdString + index);
  }

  scrollImagesRight(): void {
    const scroller = this.scrollingImages.nativeElement as HTMLElement;
    const scrollWidth = Math.min(
      scroller.scrollLeft + scroller.clientWidth,
      scroller.scrollWidth - scroller.clientWidth
    );
    scroller.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
  }

  scrollImagesLeft(): void {
    const scroller = this.scrollingImages.nativeElement as HTMLElement;
    const scrollWidth = Math.max(scroller.scrollLeft - scroller.clientWidth, 0);
    scroller.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
  }
}
